<template>
  <div class="product-add" style="width:95%;margin: auto;">



    <el-form size="small" ref="formData" :model="formData"  label-width="200px">
      <div class="common-form">基本设置</div>
          <el-form-item label="开关：" prop="is_open" >
            <el-radio-group v-model="formData.is_open" @change="open">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="积分奖励：" prop="integ">
            <el-input type='number' :disabled="disabled" v-model="formData.integ" class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="跳转文字：" prop="text">
            <el-input type='text' :disabled="disabled" v-model="formData.text" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="跳转链接：" prop="link">
            <el-input type='text' disabled v-model="formData.link_name" class="max-w460"></el-input>
            <el-button type="primary" @click="changeLink"
                  >选择链接</el-button
                >
          </el-form-item>
        
    
      <div class="common-form">新客户销售目标（默认）</div>
      
          <el-form-item label="新客户数量：" prop="new_num">
            <el-input type='number' :disabled="disabled" v-model="formData.new_num" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="新客户均价：" prop="new_per_price">
            <el-input type='number' :disabled="disabled" v-model="formData.new_per_price" class="max-w460"></el-input>
          </el-form-item>

      <div class="common-form">老客户续费目标（默认）</div>
      
          <el-form-item label="老客户数量：" prop="renew_num">
            <el-input type='number' :disabled="disabled" v-model="formData.renew_num" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="老客户均价：" prop="renew_per_price">
            <el-input type='number' :disabled="disabled" v-model="formData.renew_per_price" class="max-w460"></el-input>
          </el-form-item>   

      <div class="common-form">年度总额</div>
      
          <el-form-item label="年度总额：" prop="total">
            <el-input type='number' disabled 
             v-model="formData.new_num * formData.new_per_price+formData.renew_num * formData.renew_per_price" class="max-w460"></el-input>
          </el-form-item>

      <div v-if="disabled == false">
      <div class="common-form" >高级设置</div>   
          <el-form-item label="Bannar图片：" prop="image">
          <div class="draggable-list">
     
            <draggable class="wrapper" :disabled="disabled" v-model="formData.image">
              <transition-group>
            
                <div v-for="(item, index) in formData.image" :key="index+99">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openUpload">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


          <el-form-item label="详情：" prop="content">
          <div class="edit_container">
            <Uediter :text="formData.content" :disabled="disabled" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
          </div>
        </el-form-item>
      </div>
      <!--提交-->
      <div>
        <el-button size="small" type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-form>


    
    <!--商品图片组件-->
    <Upload v-if="isUpload" :config="{ total: 9 }" :isupload="isUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
  </div>
</template>

<script>
import SalestargetApi from "@/api/salestarget.js";
import Uediter from '@/components/UE.vue';
import Upload from "@/components/file/Upload";
import Setlink from "@/components/setlink/Setlink";
export default {
  components: {
    /*编辑器*/
    Uediter,
    Upload,
    Setlink
  },
  data() {
    return {
      /*是否选择链接*/
      is_linkset: false,

      isUpload:false,
     
      /*form表单数据*/
      formData: {
        is_open:0,
        integ: 50,
        text:"一起完成目标",
        link:"",
        new_num:"100",
        new_per_price:"1000",
        renew_num:"80",
        renew_per_price:"800",
        total:"",
        content:"",
        image:[],
        link_name:""
      },
      disabled:true,
        /*富文本框配置*/
        ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      }
    };
  },
  created() {
    this.getData();
  },

  methods: {
    /*选择链接*/
    changeLink() {
      this.is_linkset = true;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.formData.link = e.url;
        this.formData.link_name = "链接到" + " " + e.type + " " + e.name;
      }
    },
    open(e){
      console.log(e)
      this.disabled = e==0?true:false;
    },
    /*获取富文本内容*/
    contentChangeFunc(e){
      this.formData.content=e;
    },
    /*获取数据*/
    getData() {
      let self = this;
      SalestargetApi.settingDetail({}, true)
        .then(data => {
          if(data.data.values!=[]){
            console.log(data.data.values);
             self.formData = data.data.values;
             this.disabled = data.data.values.is_open==0?true:false;
          }
         
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      params.total = (params.new_num * params.new_per_price)+(params.renew_num * params.renew_per_price)
      SalestargetApi.editSetting(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {});
    },
      /*打开上传图片*/
      openUpload: function () {
      this.isUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        if(!this.formData.image){
          this.formData.image = [];
        }
        let imgs = this.formData.image.concat(e);
        this.$set(this.formData, "image", imgs);
      }
      this.isUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.formData.image.splice(index, 1);
    },

  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.video {
  width: 200px;
  height: 110px;
  margin-right: 10px;
}

.video video {
  margin-top: 10px;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/salestarget/setting/setting.vue